import {Parameter} from '../commons/parameterModel';
import {ExpressionId} from './expressionModel';
import {ResultTypesEnum} from './infer/expressionResultModel';

export interface CompareExpressionBooleanParam {
  expression: ExpressionId;
  comparator: string;
}

export interface CompareExpressionNumberParam {
  expression: ExpressionId;
  comparator: string;
  value?: number;
}

export interface CompareExpressionStringParam {
  expression: ExpressionId;
  comparator: string;
  value?: string;
}

export interface CompareExpressionDateTimeParam {
  expression: ExpressionId;
  comparator: string;
  value?: string;
}

export interface CompareExpressionTeammateParam {
  expression: ExpressionId;
  comparator: string;
  teammate?: number;
}

export interface CompareExpressionListParam {
  expression: ExpressionId;
  comparator: string;
}

export interface CompareExpressionOtherParam {
  expression: ExpressionId;
  comparator: string;
}

export function getParameterFormat(
  parameter: Parameter,
  ignoreArray: boolean = false,
): ResultTypesEnum | null {
  if (ignoreArray && Parameter.isArray(parameter)) {
    return getParameterFormat(parameter.items, ignoreArray);
  }

  if (Parameter.isExpression(parameter)) {
    return parameter.expressionFormat as ResultTypesEnum;
  }

  if (
    Parameter.isGroup(parameter) ||
    Parameter.isChannel(parameter) ||
    Parameter.isTag(parameter) ||
    Parameter.isInbox(parameter) ||
    Parameter.isTeammate(parameter) ||
    Parameter.isResponse(parameter) ||
    Parameter.isCustomField(parameter) ||
    Parameter.isTimezone(parameter)
  ) {
    return parameter.format as ResultTypesEnum;
  }

  if (
    Parameter.isString(parameter) ||
    Parameter.isNumber(parameter) ||
    Parameter.isArray(parameter) ||
    Parameter.isBoolean(parameter)
  ) {
    return parameter.type as ResultTypesEnum;
  }

  return null;
}
